var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullNoteActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FFF4DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6396 20.0732C18.8855 20.4079 19.0348 20.8328 18.9909 21.2491C18.9646 21.6697 18.8197 22.086 18.6045 22.468C18.1786 23.2405 17.4541 23.8757 16.6155 24.3264C15.7725 24.7727 14.7801 25.0259 13.7966 25.0002C12.8394 24.9744 11.8032 24.6955 11.2939 23.983C10.8021 23.262 10.9909 22.3564 11.3817 21.6011C11.7812 20.8285 12.475 20.1633 13.318 19.7126C14.161 19.2663 15.1446 18.9916 16.1369 19.0002C16.633 19.0088 17.1292 19.0774 17.5815 19.2491C18.0337 19.4122 18.4289 19.6998 18.6396 20.0689V20.0732ZM18.4025 20.1933C17.8888 19.6268 16.9667 19.5538 16.1764 19.7041C15.3685 19.85 14.6045 20.1547 13.8976 20.5281C13.1951 20.9058 12.5101 21.3307 11.9613 21.8886C11.6934 22.1676 11.4695 22.4895 11.3773 22.8414C11.2719 23.189 11.3246 23.5624 11.5397 23.8586C11.7549 24.1547 12.1237 24.3478 12.5233 24.4251C12.9272 24.5023 13.3531 24.4766 13.7659 24.3993C14.5869 24.2362 15.3422 23.9101 16.0491 23.5367C16.7516 23.159 17.4102 22.7041 17.9327 22.1461C18.4377 21.6011 18.8021 20.8457 18.4025 20.1976V20.1933Z",
    fill: "#CC962B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullNoteActive);
export default __webpack_public_path__ + "static/media/full-note-active.a97acdb6b5653b84a2099a1aa8b9ae1b.svg";
export { ForwardRef as ReactComponent };